<div class="introduction">
	<h4>{{ "i18n.mmmi.introduction.header" | translate }}</h4>
	<p>{{ "i18n.mmmi.introduction.description" | translate }}</p>
	<p>
		<a href="https://help.eiam.swiss/?c=visuallogincheck" target="_blank">{{ "i18n.mmmi.introduction.info" | translate }}</a>
	</p>
	<div *ngIf="this.identity === undefined; then loggedOut; else loggedIn"></div>
	<ng-template #loggedOut>
		<button mat-button obButton="tertiary" (click)="login()">
			Login
			<mat-icon svgIcon="login"></mat-icon>
		</button>
	</ng-template>
	<ng-template #loggedIn>
		<button mat-button obButton="tertiary" (click)="login()">
			{{ "i18n.mmmi.verification.input.refreshToken" | translate }}
			<mat-icon svgIcon="login"></mat-icon>
		</button>
	</ng-template>
</div>

<div *ngIf="this.identity !== undefined; then loggedInPage; else loggedOutPage"></div>
<ng-template #loggedInPage>
	<h4 class="vertical-spacing">{{ "i18n.mmmi.verification.user.header" | translate }}</h4>
	<p>
		<code id="currentIdentifier">
			{{ this.identity }}
		</code>

		<span *ngIf="this.expiry != null">&emsp;{{ "i18n.mmmi.verification.user.validity" | translate: { expiry: this.expiry } }}</span>
	</p>

	<h4 class="vertical-spacing">{{ "i18n.mmmi.verification.input.header" | translate }}</h4>
	<form [formGroup]="verificationForm" (ngSubmit)="verify()" class="ob-inline-form">
		<mat-form-field subscriptSizing="dynamic">
			<mat-label>User ID</mat-label>
			<input type="text" [patterns]="customPatterns" [dropSpecialCharacters]="false" [mask]="userIdMask" matInput id="userId" formControlName="userId" />
			<button mat-icon-button matSuffix obButton="tertiary" type="submit">
				<mat-icon svgIcon="arrow-right"></mat-icon>
			</button>
		</mat-form-field>

		<!-- {{ "i18n.mmmi.verification.input.button.text" | translate }} -->
	</form>

	<div class="separator vertical-spacing"></div>

	<mmmi-status></mmmi-status>
</ng-template>
<ng-template #loggedOutPage>

</ng-template>
